export default __webpack_public_path__ + "static/media/landing-phone.151f5128.svg";